<header>
  <h1>
    Categories Admin
    <button
      (click)="addCategory()"
      color="primary"
      mat-mini-fab
      matTooltip="Create category"
      >
      <mat-icon>add</mat-icon>
    </button>
  </h1>
  <search-text (search)="setSearch($event)"></search-text>
</header>
<section>
  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon>autorenew</mat-icon>
        Loading&hellip;
      </mat-card-content>
    </mat-card>
  }
  @if (!loading) {
    @if (!Categories?.length) {
      <mat-card class="no-results">
        <mat-card-content>
          <mat-icon>sentiment_dissatisfied</mat-icon>
          No categories found
        </mat-card-content>
      </mat-card>
    }
    @if (!!Categories.length) {
      <table mat-table [dataSource]="DataSource" class="categories">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let row">
            @if (row?.kind) {
              <mat-icon
                >{{ row.kind == 'offers' && 'bookmark' || ( row.kind == 'tickets'
                && 'credit_card' || 'stars') }}</mat-icon
                >
              }
              {{ row.title }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions">Actions</th>
            <td mat-cell *matCellDef="let row" class="actions">
              <button
                (click)="addCategory(row)"
                mat-icon-button
                matTooltip="Edit info."
                >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                (click)="deleteCategory(row)"
                mat-icon-button
                matTooltip="Delete category"
                >
                <mat-icon>delete</mat-icon>
              </button>
              <button
                (click)="viewListings(row)"
                mat-icon-button
                matTooltip="All category listings"
                >
                <mat-icon>list</mat-icon>
              </button>
              <button
                mat-button
                matTooltip="Cohorts"
                (click)="listCohorts(row)"
                >
                <mat-icon>people</mat-icon>
              </button>
            </td>
          </ng-container>
        </table>
        @if (PageEvent) {
          <mat-paginator
            (page)="DataSource.loadWithPageEvent($event)"
            [length]="PageEvent.length"
            [pageIndex]="PageEvent.pageIndex"
            [pageSize]="PageEvent.pageSize"
          ></mat-paginator>
        }
      }
    }
  </section>
